import { Box, BoxProps, Divider, Flex, UseCheckboxGroupReturn } from "@chakra-ui/react";
import { useTranslation } from "next-i18next";
import { ITagsData } from "src/api/server/extended-search";
import { ArrowLink } from "src/components/base/arrow-link";
import { Button } from "src/components/base/button";
import { TagsListWithBrokers } from "src/components/pages/search/components/tags-filter/components/tags-list-with-brokers";
import { IChangeFilterTag } from "src/components/pages/search/components/types";
import { ISearch } from "src/components/pages/search/search.types";

const TAGS_FILTER_BODY_CONTENT_TEST_ID = "tags-filter-body-content";

interface ITagsFilterBodyContentProps extends ISearch, Omit<BoxProps, "onChange"> {
    tagsData: ITagsData;
    showBrokers: boolean;
    getCheckboxProps: UseCheckboxGroupReturn["getCheckboxProps"];
    onChange: (changeFilterTag: IChangeFilterTag) => void;
    resetTags: () => void;
}

export const TagsFilterBodyContent = ({
    tagsData,
    showBrokers,
    onSearch,
    getCheckboxProps,
    onChange,
    resetTags,
    ...boxProps
}: ITagsFilterBodyContentProps) => {
    const { t } = useTranslation("extended-search");

    const { faqLink } = tagsData;

    return (
        <Box {...boxProps} data-test-id={TAGS_FILTER_BODY_CONTENT_TEST_ID}>
            <TagsListWithBrokers tagsData={tagsData} onSearch={onSearch} />
            <Divider pt={3} borderColor="gray.100" />
            <Flex justifyContent="space-between" pt={2}>
                <Button variant="ghost-underline" size="sm" ml={-2} onClick={resetTags}>
                    {t("buttons.reset-tags")}
                </Button>
                {faqLink && (
                    <ArrowLink display="inline-flex" alignItems="center" href={faqLink.url} target={faqLink.target}>
                        {faqLink.name}
                    </ArrowLink>
                )}
            </Flex>
        </Box>
    );
};
